import {
	makeStyles,
	Modal,
	createStyles,
	Backdrop,
	Fade,
	Theme,
} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			padding: theme.spacing(2, 4, 3),
			borderRadius: '10px',
			'@media screen and (max-width:769px)': {
				padding: theme.spacing(2, 2, 3),
			},
		},
	})
);

interface IProp {
	body: any;
	open: boolean;
	onClose(): void;
	paperStyle?: React.CSSProperties;
}
type Props = IProp;
function CustomModal({ body, open, onClose, paperStyle }: Props) {
	const classes = useStyles();
	const content = (
		<Fade in={open}>
			<div className={classes.paper} style={paperStyle}>
				{body}
			</div>
		</Fade>
	);
	return (
		<Modal
			data-testid="modalui"
			className={classes.modal}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
			open={open}
			onClose={onClose}
		>
			{content}
		</Modal>
	);
}

export default CustomModal;
